export const SecurityConstants = {
  TOKEN_HEADER_KEY: 'Authorization',
  TOKEN_PREFIX: 'Bearer'
};
